import React from 'react';
import PropTypes from 'prop-types';

import Spinner from '../Spinner/index.jsx';

import Column, { getSortMethod } from './columns.jsx';
import Configuration from './configuration.jsx';
import { ColumnHeader, ColumnHeaderSortable } from './headers.jsx';
import Table from './table.jsx';


class DataTable extends React.Component {
  sortData(rows) {
    const newRows = Array.from(rows);

    const sortMethod = getSortMethod(this.props.sort, this.props.columns);
    if (!sortMethod) {
      return newRows;
    }
    const nullRows = newRows.filter(row => !row.name && !row.title);
    const namedRows = newRows.filter(row => row.name || row.title);
    namedRows.sort(sortMethod);
    return [
      ...namedRows,
      ...nullRows
    ];
  }

  /**
   * Call the method to fetch the initial data, if one has been specified
   */
  componentDidMount() {
    if (this.props.fetch) {
      this.props.fetch();
    }
  }

  render() {
    var configuration;
    var table;

    if (this.props.loading) {
      table = (
        <div className="py-3">
          <Spinner />
        </div>
      );
    } else {
      var columns = this.props.columns;
      var configurableColumns = [];
      for (var i = 0; i < columns.length; i++) {
        var column = columns[i];

        if (column.isConfigurable) {
          configurableColumns.push(column);
        }
      }

      if (configurableColumns.length) {
        configuration = (
          <Configuration
            columns={configurableColumns}
            setting={this.props.columnVisibility}
            showColumn={this.props.showColumn}
            hideColumn={this.props.hideColumn}
          />
        );
      }

      var rows = [];
      if (this.props.rows && this.props.rows.length) {
        rows = this.sortData(this.props.rows);
      }

      table = (
        <Table
          rows={rows}
          columns={columns}
          columnSetting={this.props.columnVisibility}
          showHeader={this.props.showHeader}
          setSort={this.props.setSort}
          sort={this.props.sort}
          noDataPlaceHolder={this.props.noDataPlaceHolder}
        />
      );
    }


    return (
      <React.Fragment>
        <div className="cs-block-asset-list__configuration">
          {configuration}
        </div>
        <div className="cs-block-asset-list__table">
          {table}
        </div>
      </React.Fragment>
    );
  }
}


DataTable.propTypes = {
  /**
   * A boolean indicating whether the data for the table is being fetched
   */
  loading: PropTypes.bool,
  /**
   * An array of column objects. Each element in the array should inherit from
   * the `Columns` class defined in ./columns.jsx
   */
  columns: PropTypes.array,
  /**
   * An array of data row objects. The shape of these data objects can be
   * different depending on the table, but at a minimum must have an `id`
   * property
   */
  rows: PropTypes.array,
  /**
   * a function to fetch the data for the table. Called when the component is
   * mounted.
   */
  fetch: PropTypes.func,
  /**
   * An array indicating column visibility. each element in the array will
   * contain a string with a column id, followed by either a "+" or "-"
   * indicating whether the column should be shown or hidden. Columns not
   * listed in this array will be displayed based on their default.
   */
  columnVisibility: PropTypes.array,
  /**
   * A function to call when we want to show a column. This should updated the
   * column visibility prop.
   */
  showColumn: PropTypes.func,
  /**
   * a boolean indicating whether the header columns should be shown.
   */
  showHeader: PropTypes.bool,
  /**
   * A function to call when we want to hide a column. This should updated the
   * column visibility prop.
   */
  hideColumn: PropTypes.func,
  /**
   * A function to call when we want to change the sort option for the table.
   * This should updated the sort prop.
   */
  setSort: PropTypes.func,
  /**
   * An string indicating the sort option for the table. It will contain a
   * column id, followed by either a "+" or "-" indicating either ascending or
   * descending order. If not provided, the default sort method will be used
   * (set by the columns array)
   */
  sort: PropTypes.string
};


DataTable.defaultProps = {
  showHeader: true
};


export default DataTable;

export { Column, ColumnHeader, ColumnHeaderSortable };

